export default "__VITE_PUBLIC_ASSET__daf38979__"